"use strict";

(() => {
  'use strict';

  Nette.validators['KvikyMartCoreWebComponentsFormsPhoneNumberPhoneNumberControl_validateCountryPrefix'] = (elem, args, val) => {
    assignPhoneNumberValidator(val);
    elem.onchange = event => {
      assignPhoneNumberValidator(event.target.value);
    };
    return true;
  };
  const assignPhoneNumberValidator = countryPrefix => {
    Nette.validators['KvikyMartCoreWebComponentsFormsPhoneNumberPhoneNumberControl_validatePhoneNumber'] = (elem, args, val) => {
      if (args[countryPrefix].length === 0) {
        return true;
      }
      for (const pattern of args[countryPrefix]) {
        if (val.match(pattern)) {
          return true;
        }
      }
      return false;
    };
  };
})();